import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api'

export function usePageTracking(): void {
  const location = useLocation()
  const lastPath = useRef<string>('')

  useEffect(() => {
    // Avoid duplicate tracking on same path
    if (location.pathname === lastPath.current) return
    lastPath.current = location.pathname

    const payload = JSON.stringify({
      page_path: location.pathname,
      referrer: document.referrer || null,
    })

    const url = `${API_URL}/pv`

    // Prefer sendBeacon (non-blocking, survives page close)
    if (navigator.sendBeacon) {
      const blob = new Blob([payload], { type: 'application/json' })
      navigator.sendBeacon(url, blob)
    } else {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
        keepalive: true,
      }).catch(() => {
        // Fire-and-forget: tracking errors are silently ignored
      })
    }
  }, [location.pathname])
}
